import * as React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import styles from './NumberedCarousel.module.scss';

type CarouselProps = {
  children: Array<*>,
};

@observer
export class NumberedCarousel extends React.Component<CarouselProps, {}> {
  @observable styles = {
    width: 'auto',
    transform: '',
  };
  @observable index = 0;
  carouselContainer = {};
  carouselWrapper = {};
  carouselItem = {};

  constructor(props) {
    super(props);
    this.carouselContainer = React.createRef();
    this.carouselWrapper = React.createRef();
    this.carouselItem = React.createRef();
  }

  componentDidMount() {
    if (this.props.children.length > 1) {
      const { width } = this.carouselContainer.current.getBoundingClientRect();
      this.styles.width = `${this.props.children.length * (width - 22)}px`;
    }
  }

  changeRight() {
    if (this.props.children.length - 1 > this.index) {
      this.index++;
    }
  }

  changeLeft() {
    if (0 < this.index) {
      this.index--;
    }
  }

  render() {
    const { children } = this.props;
    const {
      styles: { width, transform },
      carouselContainer,
      carouselWrapper,
      carouselItem,
    } = this;

    const currentItem = this.index + 1;

    return (
      <div ref={carouselContainer} className={styles['carousel']}>
        <div
          ref={carouselWrapper}
          style={{ width, transform }}
          className={styles['carousel-wrapper']}
        >
          <div ref={carouselItem} className={styles['carousel-item']}>
            {children[this.index]}
          </div>
        </div>
        <div className={styles['carousel-thumbs']}>
          <div className={styles['carousel-controls']}>
            <div
              className={
                this.index === 0 ? styles['carousel-disabledButtons'] : styles['carousel-buttons']
              }
              onClick={() => this.changeLeft()}
            >
              {'<'}
            </div>
            <div className={styles['carousel-index']}>{currentItem}</div>
            <div
              className={
                currentItem === children.length
                  ? styles['carousel-disabledButtons']
                  : styles['carousel-buttons']
              }
              onClick={() => this.changeRight()}
            >
              {'>'}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
